import axiosBase from "@/api/axiosBase";

const state = {
  projectList: [],
  // 模版模型列表
  templateModel: [],

  templateModel_all: [],

  // 修改模型名称
  modelName: "",

  // 修改模型分组名称
  groupName: "",

  // 新建模型信息
  newModelData: "",

  // 新建模型分组信息
  newGroupData: "",

  // 分页查询模型列表
  modelPageList: [],

  shareModel: "",

  // 移动模型数据
  modelMove: "",

  // 删除模型数据
  modelDelete: "",

  // 复制模型
  modelCopy: "",

  // 新建模型分组列表
  newGroupList: [],

  // 删除的模型分组
  deleteGroupData: "",

  // 检查模型名称是否重复
  checkModelName: "",

  // 检查模型分组名称是否重复
  checkGroupName: "",

  // 根据modelId查询模型
  checkModelId: "",

  // 保存数据配置
  saveConfigData: "",

  // 获取数据配置
  configData: "",

  // 下载文件
  downloadFile: "",

  // 获取模型管理首页略缩图
  getHomePage: "",

  getSubArea: "",

  getMatchResult: "",

  fuzzyQuery: [],
};

const getters = {};
const mutations = {
  setProjectList(state, list) {
    if (list.length == 0) {
      state.projectList = [];
    } else {
      state.projectList = list.sort(
        (a, b) => new Date(b.createTime) - new Date(a.createTime)
      );
    }
  },

  // 获取所有的模版模型
  setGetTemplateModel(state, data) {
    state.templateModel = data;
  },

  setGetTemplateModel_all(state, data) {
    state.templateModel_all = data;
  },

  // 修改模型
  setUpdateModelData(state, newModelName) {
    state.modelPageList.forEach((element, index) => {
      if (element.id == newModelName.id) {
        state.modelPageList[index] = newModelName;
      }
    });
  },

  // 修改对应的模型名称
  setUpdateName(state, newNameData) {
    const { rowIndex, newName } = newNameData;
    state.modelPageList[rowIndex].name = newName;
  },
  // 修改对应的模型editing
  setUpdateEditing(state, newEditingData) {
    const { rowIndex, editing } = newEditingData;
    state.modelPageList[rowIndex].editing = editing;
  },
  // 修改对应的模型状态
  setUpdateStatus(state, newStatusData) {
    const allProgress = newStatusData.allProgress;
    const allStatus = newStatusData.allStatusData;
    let modelIdArray = allStatus.map((r) => r.model_id);
    let tableData = state.modelPageList;
    const statusMap = new Map();
    allStatus.forEach((element) => {
      statusMap.set(element.model_id, element.status);
    });
    tableData.forEach((item) => {
      if (statusMap.has(item.id)) {
        item.status = statusMap.get(item.id);
        item.progress = allProgress[modelIdArray.indexOf(item.id)].progress;
      }
    });
  },

  setUpdateSingleStatus(state, newStatusData) {
    const allStatus = newStatusData;
    let tableData = state.modelPageList;
    const statusMap = new Map();
    allStatus.forEach((element) => {
      statusMap.set(element.model_id, element.status);
    });
    tableData.forEach((item) => {
      if (statusMap.has(item.id)) {
        item.status = statusMap.get(item.id);
      }
    });
    console.log("state.modelPageList", state.modelPageList);
  },

  // 修改模型分组名称
  setUpdateGroupName(state, newGroupName) {
    state.groupName = newGroupName;
  },

  // 新建模型
  setNewModelBuild(state, data) {
    state.newModelData = data;
  },

  // 新建模型分组
  setNewGroupBuild(state, data) {
    state.newGroupData = data;
  },

  setShareModel(state, data) {
    state.shareModel = data;
  },

  // 移动模型
  setMoveModel(state, data) {
    state.modelMove = data;
  },

  // 删除模型
  setDeleteModel(state, data) {
    state.modelDelete = data;
  },

  // 复制模型
  setCopyModel(state, data) {
    state.modelCopy = data;
  },

  // 分页查询模型
  setGetGroupPageData(state, pageList) {
    state.modelPageList = pageList;
    if (state.modelPageList.length > 0) {
      state.modelPageList.forEach((item, index) => {
        item.editing = false;
      });
    }
  },

  // 修改模型备注（汇总笔记）
  setUpdateSummaryNote(state, data) {
    state.modelPageList.forEach((element, index) => {
      if (element.id == data.id) {
        element.remark = data.remark;
      }
    })
  },

  setTableStatus(state, data) {
    // 将 data 数组转换为一个 Map
    const dataMap = new Map();
    data.forEach((element) => {
      dataMap.set(element.model_id, element.status);
    });

    // 遍历 state.fuzzyQuery 并更新 status
    state.modelPageList.forEach((item) => {
      if (dataMap.has(item.id)) {
        item.status = dataMap.get(item.id);
      }
    });
  },

  setCheckTableStatus(state, data) {
    // 将 data 数组转换为一个 Map
    const dataMap = new Map();
    data.forEach((element) => {
      dataMap.set(element.model_id, element.status);
    });

    // 遍历 state.modelPageList.data 并更新 status
    state.fuzzyQuery.forEach((item) => {
      if (dataMap.has(item.id)) {
        item.status = dataMap.get(item.id);
      }
    });
  },

  // 获取模型分组
  setGetGroupData(state, jsonStr) {
    state.newGroupList[jsonStr.project_id] = jsonStr.groups;
  },

  // 删除模型分组
  setDeleteGroupData(state, data) {
    state.deleteGroupData = data;
  },

  // 检查模型名称是否重复
  setCheckModelName(state, data) {
    state.checkModelName = data;
  },

  // 检查模型名称是否重复
  setCheckGroupName(state, data) {
    state.checkGroupName = data;
  },

  // 根据modelId查询模型
  setCheckModelId(state, data) {
    state.checkModelId = data;
  },

  // 保存数据配置
  setSaveModelConfig(state, data) {
    state.saveConfigData = data;
  },

  // 获取数据配置
  setGetConfig(state, data) {
    state.configData = data;
  },

  // 下载文件
  setDownloadFile(state, data) {
    state.downloadFile = data;
  },

  // 获取模型管理首页略缩图
  setGetHomePage(state, data) {
    state.getHomePage = data;
  },

  setGetSubArea(state, data) {
    state.getSubArea = data;
  },

  setGetMatchResult(state, data) {
    state.getMatchResult = data;
  },

  setFuzzyQuery(state, data) {
    state.fuzzyQuery = data;
  },
};

const actions = {
  //查询项目
  getProjects({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/basedata/project",
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setProjectList", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 获取所有的模版模型
  getTemplateModel({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/model/base/template",
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setGetTemplateModel", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },
  // 获取所有的模版模型
  getTemplateModel_all({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/model/template/list_template_all",
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setGetTemplateModel_all", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 修改模型
  updateModelData({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/base/updateModel",
        data: {
          model_id: data.id,
          model_name: data.name,
          inp: data.inp,
          is_star: data.star,
          is_template: data.template,
          remark: data.remark,
          build_type: null,
          template_id: data.templateId,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setUpdateModelData", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 修改模型分组名称
  updateGroupName({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/base/updateGroup",
        data: {
          group_id: data.id,
          group_name: data.name,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setUpdateGroupName", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 新建模型
  newModelBuild({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/base/createModel",
        data: {
          model_name: data.name,
          group_id: data.groupId,
          template_id: data.templateId,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setNewModelBuild", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 新建模型分组
  newGroupBuild({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/base/createGroup",
        data: {
          group_name: data.username,
          project_id: data.projectId,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setNewGroupBuild", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 分享模型
  shareModel({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/share/create",
        data: {
          receiver_names: data.receiverNames,
          item_ids: data.fileIds,
          item_type: data.dataType,
          remark: data.remark,
          perm: data.perm,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setShareModel", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 移动模型
  moveModel({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/base/moveModel",
        data: {
          target_group_id: data.targetGroupId,
          model_ids: data.modelIds,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setMoveModel", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 删除模型
  deleteModel({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/base/deleteModel",
        data: data,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setDeleteModel", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 复制模型
  copyMode({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/base/cloneModel",
        data: {
          is_clone_result: data.isCloneResult,
          model_id: data.modelId,
          model_name: data.modelName,
          target_group_id: data.targetGroupId,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setCopyModel", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 分页查询模型
  getGroupPageData({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url:
          "/model/base/page?project_id=" +
          data.projectId +
          "&group_id=" +
          data.groupId +
          "&page=" +
          data.pageNum +
          "&page_size=" +
          data.pageSize +
          "&sort_by=" +
          data.orderByColumn +
          "&sort_direction=" +
          data.isAsc,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setGetGroupPageData", res.data.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 获取模型分组
  getGroupData({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/model/base/findGroup/" + data,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setGetGroupData", {
              project_id: data,
              groups: res.data.data,
            });
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 删除模型分组
  deleteGroupData({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/model/base/deleteGroup/" + data.groupId,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setDeleteGroupData", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 检查模型名称是否重复
  checkModelName({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url:
          "/model/base/checkModel/" + data.project_id + "/" + data.model_name,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setCheckModelName", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 检查模型分组名称是否重复
  checkModelGroupName({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url:
          "/model/base/checkGroup/" + data.project_id + "/" + data.group_name,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setCheckGroupName", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 根据modelId查询模型
  checkModelId({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/model/base/" + data,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setCheckModelId", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 保存数据配置
  saveModelConfig({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/base/saveconf",
        data: {
          bound_weather_ids: data.bound_weather_ids, // 气象数据（数组）
          hru_csv_file: data.hru_csv_file, // hru上传文件名称
          hru_dem_id: data.hru_dem_id, // 地形DEM数据
          hru_landuse_id: data.hru_landuse_id, // 用地数据
          hru_soil_id: data.hru_soil_id, // 土壤数据
          model_id: data.model_id, // 模型id
          sub_dem_id: data.sub_dem_id, // 划分子流域dem数据
          sub_hdgq_id: data.sub_hdgq_id, // 河流沟渠数据
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setSaveModelConfig", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 获取数据配置
  getConfig({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/model/base/conf/" + data,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setGetConfig", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 下载文件
  downloadFile({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/basedata/download",
        data: data,
        responseType: "blob",
      })
        .then((res) => {
          if (res.status != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setDownloadFile", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 获取模型管理首页略缩图
  getHomePage({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/model/build/thumbnail" + "?model_id=" + data,
        responseType: "blob",
      })
        .then((res) => {
          if (res.status != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setGetHomePage", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 获取子流域范围（经纬度）
  getSubArea({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "GET",
        url: "/model/build/subbasin_range?model_id=" + data,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setGetSubArea", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 获取字段匹配结果
  getMatchResult({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/basedata/gis/find/matchRes",
        data: data,
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setGetMatchResult", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },

  // 模糊查询
  fuzzyQuery({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      axiosBase({
        method: "POST",
        url: "/model/base/search",
        data: {
          group_id: data.group_id,
          project_id: data.project_id,
          search_key: data.search_key,
          search_type: data.search_type,
        },
      })
        .then((res) => {
          if (res.data.code != 200) {
            commit(
              "message/setMessage",
              { type: "error", message: res.data.msg },
              { root: true }
            );
          } else {
            commit("setFuzzyQuery", res.data.data);
          }
          resolve(res);
        })
        .catch((error) => {
          commit(
            "message/setMessage",
            { type: "error", message: error },
            { root: true }
          );
          resolve({ data: { code: 500 } });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
